import React from 'react';

import { GROUPS } from '@lumapps/groups/keys';
import { SideNavigationItem, type SideNavigationItemProps } from '@lumapps/lumx-back-office/components/SideNavigation';
import { mdiAccountMultiple } from '@lumapps/lumx/icons';
import { useTranslate } from '@lumapps/translations';

import { platformGroupsRoute } from '../../routes';

export interface PlatformGroupsSideNavigationProps extends Partial<SideNavigationItemProps> {
    isAllowed: boolean;
}

const PlatformGroupsSideNavigation = ({ isAllowed, ...restOfProps }: PlatformGroupsSideNavigationProps) => {
    const { translateKey } = useTranslate();

    if (!isAllowed) {
        return null;
    }

    return (
        <SideNavigationItem
            {...restOfProps}
            label={translateKey(GROUPS.CUSTOMER_FEEDS)}
            icon={mdiAccountMultiple}
            route={platformGroupsRoute}
        />
    );
};

PlatformGroupsSideNavigation.displayName = 'SideNavigationItem';

export { PlatformGroupsSideNavigation };
